module.exports = __webpack_public_path__ + "static/img/Video.b89c4e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prizeo/imgs/browse/Video.jpg
// module id = 2090
// module chunks = 0